import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { FieldError } from './form-utils';
import { errorClass } from './use-field-errors';

/**
 * The street/city/state/ZIP block, shared by both address forms.
 *
 * State is upper-cased as you type and capped at two characters, because that
 * is what carriers accept — catching "New York" at the keystroke is friendlier
 * than catching it at the rate lookup.
 */
export default function AddressFields({ formData, setFormData, fieldErrors, idPrefix }) {
  const set = (key) => (event) => setFormData({ ...formData, [key]: event.target.value });

  return (
    <>
      <div className="space-y-2">
        <Label htmlFor={`${idPrefix}-address1`}>Street address</Label>
        <Input
          id={`${idPrefix}-address1`}
          value={formData.address1}
          onChange={set('address1')}
          placeholder="123 Main Street"
          className={errorClass(fieldErrors.address1)}
          required
        />
        <FieldError message={fieldErrors.address1} />
      </div>

      <div className="space-y-2">
        <Label htmlFor={`${idPrefix}-address2`}>Address line 2 (optional)</Label>
        <Input
          id={`${idPrefix}-address2`}
          value={formData.address2}
          onChange={set('address2')}
          placeholder="Suite 100"
          className={errorClass(fieldErrors.address2)}
        />
        <FieldError message={fieldErrors.address2} />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor={`${idPrefix}-city`}>City</Label>
          <Input
            id={`${idPrefix}-city`}
            value={formData.city}
            onChange={set('city')}
            placeholder="Rochester"
            className={errorClass(fieldErrors.city)}
            required
          />
          <FieldError message={fieldErrors.city} />
        </div>

        <div className="space-y-2">
          <Label htmlFor={`${idPrefix}-state`}>State</Label>
          <Input
            id={`${idPrefix}-state`}
            value={formData.state}
            onChange={(e) => setFormData({ ...formData, state: e.target.value.toUpperCase() })}
            placeholder="NY"
            maxLength={2}
            className={errorClass(fieldErrors.state)}
            required
          />
          <FieldError message={fieldErrors.state} />
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor={`${idPrefix}-zip`}>ZIP code</Label>
        <Input
          id={`${idPrefix}-zip`}
          value={formData.zip}
          onChange={set('zip')}
          placeholder="14604"
          className={errorClass(fieldErrors.zip)}
          required
        />
        <FieldError message={fieldErrors.zip} />
      </div>
    </>
  );
}
